import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";

const Ctx = createContext(null);

const API_BASE = "https://xiadot.com/vendor_api";

export function VendorAuthProvider({ children }) {
  const [token, setToken] = useState(
    () => localStorage.getItem("vendor_token") || ""
  );

 const [vendor, setVendorState] = useState(() => {
  try {
    const raw = localStorage.getItem("vendor_me");
    if (raw) return JSON.parse(raw);

    // Fallback: build from old individual keys
    const id = localStorage.getItem("vendor_id");
    if (id) {
      const obj = {
        id:          Number(id),
        vendor_id:   Number(id),
        _id:         Number(id),
        name:        localStorage.getItem("vendor_name") || "",
        owner_name:  localStorage.getItem("vendor_name") || "",
        is_approved: Number(localStorage.getItem("is_approved") ?? 1),
      };
      localStorage.setItem("vendor_me", JSON.stringify(obj));
      return obj;
    }
    return null;
  } catch {
    return null;
  }
});
  const [loadingMe, setLoadingMe] = useState(false);

  // ✅ extractVendor now preserves ALL fields from DB row
  const extractVendor = (raw) => {
    const raw2 = (raw && raw.vendor) ? raw.vendor : raw;
    if (!raw2 || typeof raw2 !== "object") return null;

    const id = raw2.id || raw2._id || raw2.vendor_id || raw2.vendorId || null;

    let is_approved = null;
    if (raw2.is_approved   != null) is_approved = raw2.is_approved;
    else if (raw2.approved != null) is_approved = raw2.approved;
    else if (raw2.status   != null) is_approved = raw2.status;
    else if (raw2.vendor_status != null) is_approved = raw2.vendor_status;

    // ✅ Spread ALL fields first, then override the normalized ones
    return {
      ...raw2,           // keeps pan, gst, address, bank fields, file paths, etc.
      id,
      _id:        id,
      vendor_id:  id,
      is_approved,
    };
  };

  // ✅ Re-fetch full vendor row from DB on every page load
  useEffect(() => {
    if (!token) return;

   const storedRaw = localStorage.getItem("vendor_me");
const stored    = storedRaw ? JSON.parse(storedRaw) : null;
const vendorId  = stored
  ? (stored.id || stored._id || stored.vendor_id)
  : Number(localStorage.getItem("vendor_id")) || null;  // ← fallback
if (!vendorId) return;

    (async () => {
      try {
        setLoadingMe(true);
        const res  = await fetch(
          `${API_BASE}/vendor/auth/me.php?id=${vendorId}`,
          { headers: { Authorization: "Bearer " + token } }
        );
        const data = await res.json();

        if (data.success && data.vendor) {
          const fresh = extractVendor(data);
          if (fresh && fresh.id) {
            setVendorState(fresh);
            localStorage.setItem("vendor_me", JSON.stringify(fresh));
          }
        }
      } catch (err) {
        console.warn("me.php fetch failed, keeping cached data:", err.message);
      } finally {
        setLoadingMe(false);
      }
    })();
  }, [token]); // eslint-disable-line

  const login = ({ token: t, data: v }) => {
    if (!t) { console.error("No token received!"); return; }
    const vendorData = extractVendor(v);
    setToken(t);
    localStorage.setItem("vendor_token", t);
    if (vendorData) {
      setVendorState(vendorData);
      localStorage.setItem("vendor_me", JSON.stringify(vendorData));
    }
  };

  const logout = () => {
    setToken("");
    setVendorState(null);
    localStorage.removeItem("vendor_token");
    localStorage.removeItem("vendor_me");
  };

  // ✅ setVendor: merges updated fields into existing vendor state + localStorage
  const setVendor = (updatedFields) => {
    setVendorState(prev => {
      const merged = { ...prev, ...updatedFields };
      localStorage.setItem("vendor_me", JSON.stringify(merged));
      return merged;
    });
  };

  const value = useMemo(
    () => ({ token, vendor, loadingMe, login, logout, setVendor }),
    [token, vendor, loadingMe] // eslint-disable-line
  );

  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useVendorAuth() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useVendorAuth must be used inside VendorAuthProvider");
  return v;
}